var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1128_61)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.501 28.0816C59.429 28.2269 59.3949 28.4335 59.4252 28.5409C59.4555 28.6483 60.1369 29.3794 60.9393 30.1657C62.4204 31.6168 62.624 31.9079 62.4167 32.2783C62.1463 32.7615 32.5543 63.0262 32.2751 63.105C31.9239 63.2042 31.8126 63.119 30.1013 61.44C28.7411 60.1053 28.4042 59.929 28.033 60.3578C27.8497 60.5695 27.8298 61.3665 27.8958 65.8459C27.9384 68.7281 28.008 71.2008 28.0507 71.3409C28.0933 71.4809 28.2658 71.6371 28.4337 71.6879C28.7381 71.78 38.8375 71.6811 39.1863 71.5826C39.4197 71.5167 39.6484 71.0624 39.5764 70.8074C39.5461 70.7 38.8647 69.969 38.0623 69.1827C36.6551 67.804 36.4282 67.5034 36.5324 67.1558C36.559 67.067 40.586 62.8807 45.481 57.8529C50.3763 52.8251 57.0946 45.9243 60.4108 42.5178C64.002 38.8288 66.558 36.2909 66.7314 36.242C67.077 36.1443 67.1941 36.2343 68.9003 37.9084C70.2603 39.2429 70.5973 39.4193 70.9687 38.991C71.1522 38.7793 71.1719 37.9843 71.1048 33.5031C71.0616 30.6209 70.9938 28.1548 70.9541 28.023C70.9143 27.8912 70.7694 27.7316 70.6321 27.6683C70.3962 27.5597 60.2043 27.6499 59.8148 27.764C59.7142 27.7935 59.5729 27.9364 59.501 28.0816Z",
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1128_61)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.057 59.501C72.9118 59.429 72.7051 59.3949 72.5977 59.4252C72.4903 59.4555 71.7593 60.1369 70.973 60.9393C69.5219 62.4204 69.2308 62.624 68.8604 62.4167C68.3772 62.1463 38.1125 32.5543 38.0336 32.2751C37.9344 31.9239 38.0196 31.8126 39.6987 30.1013C41.0334 28.7411 41.2097 28.4042 40.7809 28.033C40.5691 27.8497 39.7721 27.8298 35.2927 27.8958C32.4106 27.9384 29.9378 28.008 29.7978 28.0507C29.6577 28.0933 29.5016 28.2658 29.4508 28.4337C29.3587 28.7381 29.4576 38.8375 29.5561 39.1863C29.622 39.4197 30.0763 39.6484 30.3312 39.5764C30.4386 39.546 31.1697 38.8647 31.956 38.0623C33.3347 36.6551 33.6353 36.4282 33.9829 36.5324C34.0717 36.559 38.258 40.586 43.2858 45.481C48.3136 50.3763 55.2144 57.0946 58.6209 60.4108C62.3099 64.002 64.8478 66.558 64.8967 66.7314C64.9943 67.077 64.9043 67.1941 63.2303 68.9003C61.8958 70.2603 61.7194 70.5973 62.1477 70.9687C62.3594 71.1522 63.1544 71.1719 67.6356 71.1048C70.5178 71.0616 72.9839 70.9938 73.1157 70.9541C73.2475 70.9143 73.4071 70.7694 73.4704 70.6321C73.579 70.3962 73.4888 60.2043 73.3747 59.8148C73.3452 59.7142 73.2023 59.5729 73.057 59.501Z",
    fill: "url(#paint1_linear_1128_61)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.057 59.501C72.9118 59.429 72.7051 59.3949 72.5977 59.4252C72.4903 59.4555 71.7593 60.1369 70.973 60.9393C69.5219 62.4204 69.2308 62.624 68.8604 62.4167C68.3772 62.1463 38.1125 32.5543 38.0336 32.2751C37.9344 31.9239 38.0196 31.8126 39.6987 30.1013C41.0334 28.7411 41.2097 28.4042 40.7809 28.033C40.5691 27.8497 39.7721 27.8298 35.2927 27.8958C32.4106 27.9384 29.9378 28.008 29.7978 28.0507C29.6577 28.0933 29.5016 28.2658 29.4508 28.4337C29.3587 28.7381 29.4576 38.8375 29.5561 39.1863C29.622 39.4197 30.0763 39.6484 30.3312 39.5764C30.4386 39.546 31.1697 38.8647 31.956 38.0623C33.3347 36.6551 33.6353 36.4282 33.9829 36.5324C34.0717 36.559 38.258 40.586 43.2858 45.481C48.3136 50.3763 55.2144 57.0946 58.6209 60.4108C62.3099 64.002 64.8478 66.558 64.8967 66.7314C64.9943 67.077 64.9043 67.1941 63.2303 68.9003C61.8958 70.2603 61.7194 70.5973 62.1477 70.9687C62.3594 71.1522 63.1544 71.1719 67.6356 71.1048C70.5178 71.0616 72.9839 70.9938 73.1157 70.9541C73.2475 70.9143 73.4071 70.7694 73.4704 70.6321C73.579 70.3962 73.4888 60.2043 73.3747 59.8148C73.3452 59.7142 73.2023 59.5729 73.057 59.501Z",
    stroke: "url(#paint2_linear_1128_61)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1128_61",
    x: 27.2641,
    y: 25.7113,
    width: 48.4055,
    height: 47.5793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1128_61"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1128_61",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_61",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1128_61",
    x1: 60.1461,
    y1: 25.3811,
    x2: 39.1939,
    y2: 79.5312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1128_61",
    x1: 64.3961,
    y1: 50.4433,
    x2: 33.6706,
    y2: 69.8084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignArrow);
export default __webpack_public_path__ + "static/media/design-arrow.2bcfd735f09b88c3fa6278f0776e9c99.svg";
export { ForwardRef as ReactComponent };